const SDK_VERSION = "11.4.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
